import { PureComponent } from 'preact-compat'
import { toggleClosed, toggleSticky } from '@insided/shared/services/topicService'
import { ContentType } from '@insided/shared/utils/contentType'
import { ConfigContext } from '../utils'
// eslint-disable-next-line import/no-internal-modules
import Switcher from '@insided/deprecated-preact-components/control/Switcher'

interface OptionsProps {
  onClosedChanged: (closed: boolean) => void
  onStickyChanged: (sticky: boolean) => void
  setIsLoading: (isLoading: boolean) => void
  closed: boolean
  contentType: ContentType
  privateId: number
  sticky: boolean
  onShowAlert: (type: 'success' | 'error', message?: string) => void
}

class Options extends PureComponent<OptionsProps> {
  constructor (props: OptionsProps) {
    super(props)
    this.onChangeClosed = this.onChangeClosed.bind(this)
    this.onChangeSticky = this.onChangeSticky.bind(this)
  }

  async onChangeClosed () {
    const { closed, setIsLoading, onClosedChanged, contentType, privateId, onShowAlert } = this.props
    const newClosed = !closed
    setIsLoading(true)
    try {
      await toggleClosed(contentType, privateId, newClosed)
      onClosedChanged(newClosed)
    } catch {
      onShowAlert('error')
    } finally {
      setIsLoading(false)
    }
  }

  async onChangeSticky () {
    const { onStickyChanged, setIsLoading, contentType, privateId, sticky, onShowAlert } = this.props
    const newSticky = !sticky
    setIsLoading(true)
    try {
      await toggleSticky(contentType, privateId, newSticky)
      onStickyChanged(newSticky)
    } catch {
      onShowAlert('error')
    } finally {
      setIsLoading(false)
    }
  }

  render () {
    const { closed, sticky } = this.props

    return (
      <ConfigContext.Consumer>
        {({ contentTypeConfig }) => {
          return (
            <div className='topic-info__details-item'>
              <label>Options</label>
              {contentTypeConfig.sticky && <div>
                <Switcher
                  on={sticky}
                  onChange={this.onChangeSticky}
                  label='Sticky topic'
                  ControlSwitcherProps={{ 'data-qa': 'sticky-topic' }}
                />
              </div>}
              <div>
                <Switcher
                  on={closed}
                  onChange={this.onChangeClosed}
                  label='Close topic'
                  ControlSwitcherProps={{ 'data-qa': 'close-topic' }}
                />
              </div>
            </div>
          )
        }}
      </ConfigContext.Consumer>
    )
  }
}

export default Options
